<template>
    <div
        ref="renderer"
    >
        <camera-view
            :controller="viewController"
            :view="currentView"
            @camera-loading="cameraLoading"
        />
    </div>
</template>

<script>
    import CameraView from './Three/CameraView.vue';

    import allStores from '../stores/all';

    import emitter from '../helpers/bus';

    export default {
        mixins: [allStores],

        components: {
            CameraView,
        },

        computed: {
            currentStep() {
                return this.appStore.currentStep;
            },

            viewController() {
                return this.customizerStore.viewController;
            },

            currentView() {
                return this.customizerStore.currentView;
            },
        },

        watch: {
            currentStep() {
                this.$nextTick(() => {
                    this.resize();
                });
            },
        },

        mounted() {
            this.resize();
        },

        methods: {
            resize() {
                const parent = this.$el.closest('.cz3');

                if (parent) {
                    const excludes = Array.from(parent.querySelectorAll('.cz3-renderer-exclude'));

                    let excludeHeight = 0;

                    // Margins.
                    const isLarge = window.innerWidth > 1024;

                    if (isLarge) {
                        excludeHeight += 24 + 24;
                    } else {
                        excludeHeight += 16;
                    }

                    excludes.forEach((el) => {
                        excludeHeight += el.offsetHeight;
                    });

                    this.$refs.renderer.style.setProperty('--exclude-height', `${excludeHeight}px`);
                }
            },

            cameraLoading(status) {
                // Hide loading indicator when camera view is done.
                // We are not going to arm the loading screen here since we use smooth fading for minor updates.
                // The status will be armed at:
                // * At load
                // * When reloading a blueprint.
                if (status === false) {
                    this.appStore.setIsLoading(status);

                    emitter.$emit('clearPoster', {
                        duration: 350,
                        allowRelease: true,
                    });
                }
            },
        },
    };
</script>
